import { CustomPushNotificationLevelEnum } from '@api/enum/notification.enum';
import { Chip, Table } from '@hyperflake/react-ui-library';

import { useNotificationList } from 'modules/notification/hooks/useNotificationList';
import moment from 'moment';

const NotificationList = () => {
    const { data, isLoading } = useNotificationList();

    return (
        <>
            <Table
                className="mt-4"
                borderStyle="divider"
                hover
                isLoading={isLoading}
                data={data}
                columns={[
                    {
                        header: 'Title',
                    },
                    {
                        header: 'Text',
                    },
                    {
                        header: 'Level',
                    },
                    {
                        header: 'Created',
                    },
                ]}
                renderRow={(row) => (
                    <Table.Row key={row._id}>
                        <Table.Cell>{row.title}</Table.Cell>
                        <Table.Cell>{row.message}</Table.Cell>
                        <Table.Cell>
                            <Chip
                                label={row.level}
                                color={row.level === CustomPushNotificationLevelEnum.RESELLER ? 'success' : 'warning'}
                                variant="outlined"
                            />
                        </Table.Cell>
                        <Table.Cell>
                            <div> {moment(row?.createdAt, 'YYYYMMDDHHmmss').format('h:mm A DD MMM, YY')}</div>
                        </Table.Cell>
                    </Table.Row>
                )}
            />
        </>
    );
};

export default NotificationList;
